import React from 'react';
import '../../styles/style.css';

const Sign_Up_Updates = () => (
  <div className="Sign_Up_Updates">
    <div className="container">
      <h1>Sign up for updates and exclusive offers</h1>
      <p>You can cancel the newsletter anytime! Please read our Privacy Policy.</p>
      <form>
        <div className="row mt-5">
          <div className="col-5">
            <input type="text" className="form-control" placeholder="Full Name" name="email" />
          </div>
          <div className="col-5">
            <input type="text" className="form-control" placeholder="Email Address" name="pswd" />
          </div>
          <div className="col-2">
            <button>Subscribe</button>
          </div>
        </div>
      </form>
    </div>
  </div>
);

export default Sign_Up_Updates;